import _ from 'lodash'
// import { createSelector } from 'reselect'

export const getAttachmentIdParam = (state, props) =>
  parseInt(_.get(props, 'match.params.attachmentId', null), 10)

export const getLeadAttachmentsLoading = state =>
  _.get(state, 'leadAttachmentActions.loading', false)

export const getLeadAttachments = (state, props) =>
  _.get(state, 'leadAttachmentActions.leadAttachments.data', false)



// WEBPACK FOOTER //
// ./src/selectors/lead/attachments.js